import { render, staticRenderFns } from "./molecule.ugcConfirmDesignStep.vue?vue&type=template&id=6f786e50"
import script from "./molecule.ugcConfirmDesignStep.vue?vue&type=script&lang=ts"
export * from "./molecule.ugcConfirmDesignStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports